const { getElement } = window.BAO.Utils

export class FooterMenus extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.initialise()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.initialise.bind(this))

    this.els.header.elements.forEach(itemEl => {
      itemEl.addEventListener('click', this.handleClick.bind(this))
      itemEl.addEventListener('mouseover', this.handleMouseOver.bind(this))
    })
  }

  initialise () {
    let containerHeight = 0

    this.els.container.elements.forEach(containerEl => {
      const thisBody = getElement('[data-footer-menu-el="body"]', {
        context: containerEl,
      })

      containerEl.style.setProperty(
        '--Menu_Height',
        `${thisBody.offsetHeight}px`,
      )

      if (containerHeight < thisBody.offsetHeight) {
        containerHeight = thisBody.offsetHeight
      }
    })

    this.style.setProperty('--Largest_Height', `${containerHeight}px`)
  }

  handleMouseOver (e) {
    if (!window.matchMedia('(min-width: 901px').matches) return

    this.handleClick(e)
  }

  handleClick (e) {
    e.preventDefault()

    this.els.container.elements.forEach(containerEl => {
      containerEl.setAttribute('aria-current', false)
    })

    e.currentTarget.parentNode.setAttribute('aria-current', true)
  }
}

customElements.define('footer-menus', FooterMenus)
